import { type TravelTransportTypeEnum } from '../enums/TravelTransportTypeEnum'
import { TravelAddress, type TravelAddressConstructor } from '../TravelAddress'

export interface TravelDestinationConstructor {
  id: number
  sequence: number
  transport: TravelTransportTypeEnum
  departurePlaceId: string
  departureReference: string
  departureDate: ISODateString
  departureAddress: TravelAddressConstructor
  arrivalPlaceId: string
  arrivalReference: string
  arrivalDate: ISODateString
  arrivalAddress: TravelAddressConstructor
}

export class TravelDestination {
  readonly id: number
  readonly sequence: number
  readonly transport: TravelTransportTypeEnum
  readonly departurePlaceId: string
  readonly departureReference: string
  readonly departureDate: Date
  readonly departureAddress: TravelAddress
  readonly arrivalPlaceId: string
  readonly arrivalReference: string
  readonly arrivalDate: Date
  readonly arrivalAddress: TravelAddress

  constructor(data: TravelDestinationConstructor) {
    this.id = data.id
    this.sequence = data.sequence
    this.transport = data.transport
    this.departurePlaceId = data.departurePlaceId
    this.departureReference = data.departureReference
    this.departureDate = new Date(data.departureDate)
    this.departureAddress = new TravelAddress(data.departureAddress)
    this.arrivalPlaceId = data.arrivalPlaceId
    this.arrivalReference = data.arrivalReference
    this.arrivalDate = new Date(data.arrivalDate)
    this.arrivalAddress = new TravelAddress(data.arrivalAddress)
  }

  // One-way trips are saved with arrival = departure, so any other
  // arrival is a return trip (Angular `travel.request.modal.ctrl.js:113-116`)
  get isRoundTrip(): boolean {
    return this.arrivalDate.getTime() !== this.departureDate.getTime()
  }
}
